export default interface IApp {
	getRoutes: () => void;
}

export enum EnvStages {
	LOCAL = "local",
	DEV = "dev",
	PROD = "prod"
}
